import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="terms">
      <Header />
      <main className="content">
        <div className="ct__richtext">
          <p>
            <br />
            <u>Effective Date: November 6, 2025</u>
            <br />
            <br />
            IMPORTANT NOTICE: THIS AGREEMENT (AS DEFINED BELOW) IS SUBJECT TO
            BINDING ARBITRATION AND A WAIVER OF CLASS ACTION RIGHTS AS DETAILED
            IN THE DISPUTE RESOLUTION SECTION BELOW.
            <br />
            <br />
          </p>
          <h2>Rivergrove Terms of Service</h2>
          <p>
            This is an agreement between you and Rivergrove LLC (together with
            its affiliates, collectively “Rivergrove,” “we,” “us,” or “our”).
            These Rivergrove Terms of Service (“Terms”), and any terms
            incorporated in these Terms or made available through any Rivergrove
            OffeRartoria (collectively, the “Agreement”), govern the use of and
            access to Rivergrove Offerings and Non-Rivergrove Offerings
            (collectively, “Offerings”). “Rivergrove Offerings” are all
            Rivergrove-manufactured or Rivergrove-branded: (1) services,
            features, software, websites, and applications (“Services”); and (2)
            hardware products (“Products”). “Non-Rivergrove Offerings” are
            services, features, software, websites, applications, products, and
            content that are not manufactured by Rivergrove or
            Rivergrove-branded that you may be allowed to access or acquire
            through a Rivergrove Offering.
            <br />
          </p>
          <h3 id="1general">1. GENERAL</h3>
          <p>
            <br />
            The term “you” means any person or entity who purchases, accesses,
            or uses an Offering, including by creating an account associated
            with an Offering.{" "}
          </p>
          <p>
            You must be at least 13 years old to use the Rivergrove Offerings.
            If you are between the ages of 13 and 18, you may use the Rivergrove
            Offerings only with consent of a parent or guardian who agrees to
            this Agreement on your behalf.
          </p>
          <p>
            By using or accessing any Offering, you agree to be bound to this
            Agreement on behalf of yourself, all members of your household, and
            all other people and entities that use your Products or access any
            OffeRartoria through your account (collectively, “Covered Parties”).
            You are responsible for any use of the Offerings by Covered Parties.
          </p>
          <p>
            If you’re agreeing to this Agreement on behalf of an entity, such as
            the company you work for, you represent to us that you have legal
            authority to bind that entity.
            <br />
            <br />
          </p>
          <h3 id="2ringofferings">2. Rivergrove OFFERINGS</h3>
          <p>
            <br />
            <strong>a. Account</strong>
            <br />
            <br />
            You may need a Rivergrove account to use the Rivergrove Offerings,
            and you may be required to be logged into the account and have a
            valid payment method associated with it. If there is a problem
            charging your selected payment method, we may charge any other valid
            payment method associated with your account. You are responsible for
            maintaining the confidentiality of your account and password and for
            restricting access to your account, and you agree to accept
            responsibility for all activities that occur under your account or
            password. Rivergrove reserves the right to the fullest extent
            allowed by applicable law to refuse service, terminate accounts,
            terminate or suspend your rights to use or access the Services or
            your account, remove or edit content, or cancel or refuse to accept
            orders for any reason in its sole discretion. You may not use any
            Rivergrove Offerings if you are the subject of U.S. sanctions or of
            sanctions consistent with U.S. law imposed by the governments of the
            country where you are using the Rivergrove Offerings. You must
            comply with all U.S. or other export and re-export restrictions that
            may apply to the Rivergrove Offerings.
            <br />
            <br />
            <strong>
              b. Content, Your Responsibilities, and System Requirements
            </strong>
            <br />
            <br />
            Certain Rivergrove Offerings allow you to store, access, retrieve,
            and manage videos, audio, images, text, and other information or
            content captured by Products or provided to us in connection with
            Rivergrove Offerings (including content you post, submit, and/or
            share with other parties, for instance, through Rivergrove
            Neighbors, the Rivergrove App, the Rivergrove Community, or via a
            share link) (collectively, “Content”). You authorize and direct us
            to store, process, reproduce, and use your Content in connection
            with our operation and provision of the Rivergrove Offerings.
            <br />
            <br />
            You must use the Rivergrove Offerings in accordance with this
            Agreement and any instructions or specifications we provide you, and
            only for their intended purpose. You are responsible for how your
            Rivergrove Offerings are set-up, configured, and used (or misused).
            For instance, you are responsible for how your cameras and other
            Products are positioned, what your Products record, what Content
            your Rivergrove Offerings store, whether audio recording is turned
            on, what features are enabled, and what zones are being monitored
            and recorded. You must ensure that Rivergrove Offerings are only
            used in a manner that complies with applicable laws and regulations,
            including: (i) any required consent and notice to third parties
            relating to recording or shaRartoria of Content or use of facial
            recognition or other types of detection features; and (ii) laws
            relating to recording or shaRartoria of Content that includes public
            spaces or private areas beyond the boundary of your property.
            <br />
            <br />
            The Rivergrove Offerings will not be accessible or fully functional
            without: (1) Wi-Fi internet access that has reliable bandwidth and
            connectivity, and is always on; (2) an enabled and supported mobile
            device; and (3) other required system elements that have been
            specified by Rivergrove or communicated to you (including in
            applicable product specifications or documentation). It is your
            responsibility to ensure that you have all required system elements
            and that they are compatible and properly configured to work with
            the Rivergrove Offerings and that Rivergrove Offerings are fully
            functioning and properly maintained. If you alter any hardware,
            software, or other element of Rivergrove Offerings, it may prevent
            the proper operation of Rivergrove Offerings.
            <br />
            <br />
            <strong>c. Subscription Plans</strong>
            <br />
            <br />
            Rivergrove offers a number of subscriptions (each, a “Subscription
            Plan”). For more information and terms, please see{" "}
            <Link onClick={toTop} to="/contact">
              Rivergrove Subscription Plans
            </Link>
            .
            <br />
            <br />
            <strong>i. Promotional Trials.</strong> We sometimes offer certain
            customers trials or other promotional offers to Subscription Plans,
            which are subject to this Agreement. If you do not enter into a paid
            Subscription Plan before the end of your trial period (if any), any
            video, image, audio, and/or other Content captured by your Products
            associated with your Subscription Plan (“Subscription Plan
            Recordings”) will no longer be accessible to you.
            <br />
            <br />
            <strong>ii. Paid Monthly and Annual Subscriptions.</strong> At any
            time, you may enroll in any available monthly or annual paid
            Subscription Plans, which will continue until you or we cancel your
            subscription. From time to time, we may offer different subscription
            terms, and the fees for such subscriptions may vary. Subscription
            fees may be subject to tax and are non-refundable. Unless you notify
            us before a charge that you want to cancel or do not want to auto
            renew, you understand your Subscription Plan will automatically
            continue and you authorize us (without notice to you, unless
            required by applicable law) to collect the then-applicable
            subscription fees and any taxes, using any payment method we have on
            record for you.
            <br />
            <br />
            Subscription fees are billed or charged on the first day of the
            applicable subscription period. If any payment is not received or is
            returned unpaid, or if any credit card or similar transaction is
            rejected or denied, Rivergrove reserves the right to cancel your
            Subscription Plan unless you provide us with a new payment method.
            If you provide us with a new payment method and are successfully
            charged before your Subscription Plan is cancelled, your new
            subscription period will be based on the original renewal date and
            not the date of the successful charge.
            <br />
            <br />
            If you purchased a Subscription Plan on amazon.com, you also agree
            to Amazon’s{" "}
            <Link onClick={toTop} to="/terms">
              Conditions of Use
            </Link>{" "}
            and{" "}
            <Link onClick={toTop} to="/privacy">
              Privacy Notice
            </Link>
            .
            <br />
            <br />
            <strong>iii. Cancellation of Subscription Plans.</strong> If you
            purchased your Subscription Plan on www.rivergrove.blog, please see{" "}
            <Link onClick={toTop} to="/contact">
              Upgrading, Changing, or Canceling your Subscription Plan
            </Link>{" "}
            for more information about canceling your Subscription Plan. If you
            purchased your Subscription Plan on amazon.com, you can cancel or
            adjust your subscription settings in{" "}
            <Link onClick={toTop} to="/">
              Your Memberships &amp; Subscriptions
            </Link>{" "}
            within your amazon.com account. After your cancellation, you will
            continue to enjoy access to the Subscription Plan and your
            Subscription Plan Recordings until your subscription period ends;
            you will not receive a refund of any subscription fees already paid.
            After your subscription period ends, your Subscription Plan
            Recordings will no longer be accessible to you.
            <br />
            <br />
            <strong>d. ShaRartoria Content</strong>
            <br />
            <br />
            Rivergrove Offerings may also allow you to post, submit, and/or
            share (“Share”) Content to or with Rivergrove and/or with other
            parties.
            <br />
            <br />
            You may Share Content, so long as it is not illegal, obscene,
            threatening, defamatory, invasive of privacy, infringing of
            intellectual property or other rights (including publicity and
            privacy rights), or otherwise injurious to third parties or
            objectionable, and does not consist of or contain software viruses,
            political campaigning, commercial solicitation, chain letters, mass
            mailings, or any form of “spam” or unsolicited commercial electronic
            messages. You may not use a false e-mail address, impersonate any
            person or entity, or otherwise mislead as to the origin of the
            Content. Rivergrove has the right, but not the obligation, to
            monitor and edit or remove any Content. You may not Share any
            Content or other materials to us (whether by email, in your
            interactions with Rivergrove’s customer support personnel, or
            otherwise) or use Content in a manner that violates the{" "}
            <Link onClick={toTop} to="/contact">
              Neighbors By Rivergrove Community Guidelines
            </Link>
            , which are hereby incorporated by reference. You represent and
            warrant that you own or otherwise control all of the rights to the
            Content that you Share; that such Content is accurate; and such
            Content does not violate this Agreement. Rivergrove takes no
            responsibility and assumes no liability for any Content Shared by
            you or any third-party. If you see Content that you believe violates
            this Agreement, please flag it in the mobile application or report
            it to us by emailing{" "}
            <Link onClick={toTop} to="mailto:depot@rivergrove.blog">
              depot@rivergrove.blog
            </Link>
            .
            <br />
            <br />
            If you do Share Content through Rivergrove Offerings, including
            through Rivergrove Neighbors, the Rivergrove App, the Rivergrove
            Community, or via a share link, you grant Rivergrove an unlimited,
            nonexclusive, royalty-free, perpetual, irrevocable, and fully
            sublicensable right to use, store, delete, reproduce, modify, adapt,
            publish, perform, translate, create derivative works from,
            distribute, and display such Content throughout the world for any
            purpose in any media. You grant Rivergrove and sublicensees the
            right to use the name that you Share in connection with such
            Content.
            <br />
            <br />
            <strong>e. Access And Use</strong>
            <br />
            <br />
            Subject to your compliance with this Agreement, Rivergrove grants
            you a limited, non-transferable, non-exclusive right to access and
            make personal and non-commercial use of the Rivergrove Offerings. If
            you are a business that purchased a Rivergrove OffeRartoria for
            business purposes (such as using Rivergrove Offerings on your
            business premises or enabling tenants to use the Rivergrove
            Offerings), Rivergrove grants you a limited, non-transferable,
            non-exclusive right to access and make internal, lawful business use
            of that Rivergrove Offering; however, this license does not include
            any right to resell the Rivergrove Offerings, or otherwise make the
            Rivergrove Offerings available for third parties.
            <br />
            <br />
            <strong>f. Privacy</strong>
            <br />
            <br />
            Please see Rivergrove’s{" "}
            <Link onClick={toTop} to="/privacy">
              Privacy Notice
            </Link>{" "}
            for information regarding the collection and use of personal
            information collected through the Rivergrove Offerings.
            <br />
            <br />
            We also use third-party web and app analytics services on our
            websites and mobile apps. Some of these services use automated
            technologies to collect and analyze information, including personal
            information (such as email, device identifier, and IP addresses) to
            understand how you use our websites and mobile apps. Web and app
            analytics services help us improve features, evaluate the
            effectiveness of our marketing, and, ultimately, optimize the
            customer experience. To learn more about these analytics services,
            please see our{" "}
            <Link onClick={toTop} to="/privacy">
              Cookie Policy
            </Link>
            .
            <br />
            <br />
            To make a selection regarding web and app analytics cookies placed
            by third parties and personalized advertising by third parties,
            please visit the Control Center and/or Cookie Settings Manager to
            set your preferences.
            <br />
            <br />
            <strong>
              g. Rivergrove Artificial Intelligence and Machine Learning
              Services
            </strong>
            <br />
            <br />
            Rivergrove may make available Rivergrove Offerings that utilize
            artificial intelligence, computer vision, machine learning, or
            similar technologies (“AI Technologies”), such as: (1)
            community-based event detection (e.g., lost pet detection); (2)
            Smart Video Search and Smart Video Descriptions; and (3) Virtual
            Security Guard. You direct Rivergrove to use AI Technologies to
            provide such Rivergrove Offerings to you. We do not guarantee AI
            Technologies’ functionality or that the content it generates is
            accurate, reliable, always available, or complete. You should always
            verify the accuracy of any outputs from AI Technologies prior to
            relying on them.
            <br />
            <br />
            <strong>h. Software</strong>
            <br />
            <br />
            You may use the software (including updates) incorporated in any
            Rivergrove OffeRartoria (the “Software”) solely for purposes of
            enabling you to use the Rivergrove Offerings and as permitted by
            this Agreement. By using any Rivergrove Offering, you consent to the
            automatic installation of updates to the Software at any time and
            without notice to you. You may not incorporate any portion of the
            Software into other programs or compile any portion of it in
            combination with other programs or otherwise copy (except to
            exercise rights granted in this section), modify, create derivative
            works of, distribute, assign any rights to, or license the Software
            in whole or in part. Software used in any Rivergrove OffeRartoria is
            the property of Rivergrove or its suppliers or licensors and is
            protected by U.S. and international copyright laws. When you use the
            Software, you may also be using the services of one or more third
            parties, such as a wireless carrier or a mobile software provider,
            and such usage is subject to the third parties’ fees, terms, and
            policies.
            <br />
            <br />
            You may not reverse engineer, decompile or disassemble, tamper with,
            or bypass any security associated with the Software, whether in
            whole or in part. If you are a U.S. government end user, we are
            licensing the Software to you as a “Commercial Product” as that term
            is defined in the U.S. Code of Federal Regulations (see 48 C.F.R. §
            2.101), and the rights we grant you to the Software are the same as
            the rights we grant to all others under this Agreement. In the event
            of any conflict between this Agreement and any other Rivergrove or
            third-party terms applicable to any portion of the Software, such as
            open-source license terms, such other terms will control as to that
            portion of the Software and to the extent of the conflict.
            <br />
            <br />
          </p>
          <h3 id="3changestoagreementorofferings">
            3. CHANGES TO AGREEMENT OR OFFERINGS
          </h3>
          <p>
            <br />
            We reserve the right to suspend, discontinue, or make changes to the
            Offerings (including to their description, pricing, and
            availability), this site, our policies, and this Agreement at any
            time. Your continued use of any OffeRartoria after the effective
            date of any such change constitutes your acknowledgement and
            acceptance of the change.
            <br />
            <br />
          </p>
          <h3 id="4trademarksandcopyrights">4. TRADEMARKS AND COPYRIGHTS</h3>
          <p>
            <br />
            All content included in or made available through any Rivergrove
            Offering, such as text, graphics, logos, button icons, images, audio
            clips, digital downloads, data compilations, and software (including
            any compilations thereof), is the property of Rivergrove or its
            content suppliers and protected by U.S. and international copyright
            laws. All graphics, logos, page headers, button icons, scripts, and
            service names included in or made available through any Rivergrove
            OffeRartoria are trademarks or trade dress of Rivergrove in the U.S.
            and other countries and may not be used in connection with any
            product or service that is not Rivergrove’s, in any manner that is
            likely to cause confusion among customers, or in any manner that
            disparages or discredits Rivergrove. All trademarks or trade dress
            not owned by Rivergrove that appear in any Rivergrove OffeRartoria
            are the property of their respective owners, who may or may not be
            affiliated with, connected to, or sponsored by Rivergrove.
            <br />
            <br />
            All rights not expressly granted to you in this Agreement are
            reserved and retained by Rivergrove or its licensors, suppliers,
            publishers, rightsholders, or other content providers.
            <br />
            <br />
            We respect others’ intellectual property rights, and we reserve the
            right to delete or disable Content alleged to be infringing, and to
            terminate the accounts of alleged infringers. To review the complete
            Copyright Dispute Policy and learn how to report potentially
            infringing content,{" "}
            <Link onClick={toTop} to="/">
              click here
            </Link>
            .
            <br />
            <br />
          </p>
          <h3 id="5consenttoelectroniccontactusercommunications">
            5. CONSENT TO ELECTRONIC CONTACT; USER COMMUNICATIONS
          </h3>
          <p>
            <br />
            When you use any Rivergrove Offering, or send e-mails, text
            messages, and other communications from your desktop or mobile
            device to us, you may be communicating with us electronically. You
            consent to receive communications from us electronically, such as
            e-mails, texts, mobile push notices, or notices and messages on this
            site or through the Services. You agree that all agreements,
            notices, disclosures, and other communications that we provide to
            you electronically satisfy any legal requirement that such
            communications be in writing.
            <br />
            <br />
          </p>
          <h3 id="6noguaranteesnolifeandsafetyorcriticaluses">
            6. NO GUARANTEES; NO LIFE AND SAFETY OR CRITICAL USES
          </h3>
          <p>
            <br />
            We do not guarantee that the Rivergrove Offerings, including any
            notifications or alerts, are accurate, reliable, always available,
            timely, or complete. The Rivergrove Offerings are provided for
            informational purposes only. You agree that Rivergrove is not
            responsible for any damages caused by the failure, unavailability,
            error, or delay of the Rivergrove Offerings (including loss of your
            Content), regardless of whether such issue is within Rivergrove’s
            control. Except for Professional MonitoRartoria Solutions (as
            defined below), Rivergrove Offerings are not monitored security
            services or emergency notification services. Unless you have
            separately purchased Professional MonitoRartoria Solutions that
            include emergency notification services, you understand that
            Rivergrove will neither monitor emergency notifications nor attempt
            to dispatch emergency authorities to your home.
            <br />
            <br />
          </p>
          <h3 id="7returnandrefunds">7. RETURN AND REFUNDS</h3>
          <p>
            <br />
            <strong>a. Risk of Loss</strong>
            <br />
            <br />
            All purchases of physical Offerings sold by us are made pursuant to
            a shipment contract. This means that the risk of loss and title for
            such goods pass to you upon delivery to the carrier.
          </p>
          <p>
            <strong>b. Return Policy and Refunds</strong>
            <br />
            <br />
            Rivergrove does not take title to returned physical Offerings until
            the item arrives at our fulfillment center. At our discretion, a
            refund may be issued without requiRartoria a return. In this
            situation, Rivergrove does not take title to the refunded item. For
            more information about our returns and refunds, please see the{" "}
            <Link onClick={toTop} to="/returns">
              Return Policy
            </Link>
            .
          </p>
          <p>
            <strong>c. Order Limits / End-User Customers Only</strong>
            <br />
            <br />
            Rivergrove reserves the right, in its sole discretion, to refuse or
            cancel any order and limit order quantity. Rivergrove may also
            require additional qualifying information prior to accepting or
            processing any order.
            <br />
            <br />
          </p>
          <h3 id="8otherterms">8. OTHER TERMS</h3>
          <p>
            <br />
            <strong>i. Professional MonitoRartoria Solutions.</strong> The{" "}
            <Link onClick={toTop} to="/terms">
              Professional MonitoRartoria Terms and Conditions
            </Link>{" "}
            apply if you use a Professional MonitoRartoria Solution (as such
            term is defined therein).
            <br />
            <br />
            <strong>ii. Internet Service.</strong> Certain Subscription Plans
            include Services that enable Products to provide internet access.
            The{" "}
            <Link onClick={toTop} to="/">
              Internet Access Additional Terms
            </Link>{" "}
            apply if you purchase or access any Services that provide internet
            access.
            <br />
            <br />
            <strong>iii. Sidewalk.</strong> If Amazon Sidewalk is turned on,
            Sidewalk will use a small portion of your internet bandwidth and the
            approximate location of your compatible Products to help keep other
            devices connected to the internet and find lost items by reporting
            their approximate location to the owner. If your Rivergrove account
            is linked to your Amazon account, Amazon Sidewalk will also be
            turned on for any Echo devices on your Amazon account. You can
            adjust your Sidewalk settings in the{" "}
            <Link onClick={toTop} to="/contact">
              Control Center
            </Link>
            .
            <br />
            <br />
            <strong>iv. Non-Rivergrove Offerings.</strong> When you use a
            Non-Ring Offering, you may be subject to separate terms, policies,
            and fees from the party providing that Non-Rivergrove Offering.
            Rivergrove is not responsible for examining or evaluating
            Non-Rivergrove Offerings, does not warrant Non-Rivergrove Offerings,
            and does not guarantee Non-Ring Offerings are or will remain
            compatible with Rivergrove Offerings. In connection with certain
            Non-Rivergrove Offerings, we may provide links to websites or apps
            operated by other parties. If you purchase any of the products or
            services offered by those parties, you are purchasing directly from
            those parties, not from Rivergrove, and Rivergrove has no
            responsibility for those purchases.
            <br />
            <br />
          </p>
          <h3 id="9norepresentationsorwarranties">
            9. NO REPRESENTATIONS OR WARRANTIES
          </h3>
          <p>
            <br />
            THE OFFERINGS AND ALL INFORMATION, CONTENT, MATERIALS, PRODUCTS,
            SOFTWARE, AND OTHER SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE
            TO YOU THROUGH THE Rivergrove OFFERINGS ARE PROVIDED BY Rivergrove
            ON AN “AS IS” AND “AS AVAILABLE” BASIS. Rivergrove MAKES NO
            REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO
            THE OPERATION OF THE OFFERINGS, OR THE INFORMATION, CONTENT,
            MATERIALS, PRODUCTS, SOFTWARE, OR OTHER SERVICES INCLUDED ON OR
            OTHERWISE MADE AVAILABLE TO YOU THROUGH THE OFFERINGS. YOU AGREE
            THAT YOUR USE OF THE OFFERINGS IS AT YOUR SOLE RISK. TO THE FULLEST
            EXTENT PERMISSIBLE BY LAW, Rivergrove DISCLAIMS ALL WARRANTIES,
            EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY
            AND FITNESS FOR A PARTICULAR PURPOSE. Rivergrove DOES NOT WARRANT
            THAT THE OFFERINGS, INFORMATION, CONTENT, MATERIALS, PRODUCTS
            (INCLUDING SOFTWARE) OR OTHER SERVICES INCLUDED ON OR OTHERWISE MADE
            AVAILABLE TO YOU THROUGH THE Rivergrove OFFERINGS, OR ELECTRONIC
            COMMUNICATIONS SENT FROM Rivergrove, ARE FREE OF VIRUSES OR OTHER
            HARMFUL COMPONENTS.
            <br />
            <br />
          </p>
          <h3 id="10exclusionofliability">10. EXCLUSION OF LIABILITY</h3>
          <p>
            <br />
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, Rivergrove SHALL
            NOT BE LIABLE FOR ANY SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES
            OR LOST PROFITS ARISING OUT OF OR RELATED TO THIS AGREEMENT OR THE
            OFFERINGS, HOWEVER INCURRED, WHETHER SUCH LIABILITY IS ASSERTED ON
            THE BASIS OF CONTRACT, TORT (INCLUDING NEGLIGENCE OR STRICT
            LIABILITY), OR OTHERWISE, EVEN IF SUCH PARTY IS ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES IN ADVANCE BY THE OTHER PARTY.
            <br />
            <br />
          </p>
          <h3 id="11limitationsofliability">11. LIMITATIONS OF LIABILITY</h3>
          <p>
            <br />
            TO THE EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
            Rivergrove’S TOTAL LIABILITY TO YOU FOR ALL DAMAGES, LOSSES, AND
            CAUSES OF ACTION (WHETHER IN CONTRACT, TORT, OR OTHERWISE) EXCEED
            THE AMOUNT PAID BY YOU, IF ANY, WITHIN THE PRIOR TWELVE (12) MONTHS
            FOR THE OFFERINGS AT ISSUE. THIS LIMITATION IS CUMULATIVE AND WILL
            NOT BE INCREASED BY THE EXISTENCE OF MORE THAN ONE INCIDENT OR
            CLAIM. TO THE EXTENT PERMITTED BY APPLICABLE LAW, Rivergrove
            DISCLAIMS ALL LIABILITY OF ANY KIND RELATING TO NON-Rivergrove
            OFFERINGS AND THIRD-PARTY RETAILERS, RESELLERS OR DISTRIBUTORS OF
            Rivergrove OFFERINGS.
            <br />
            <br />
          </p>
          <h3 id="12forcemajeure">12. FORCE MAJEURE</h3>
          <p>
            <br />
            Rivergrove IS NOT RESPONSIBLE FOR ANY CONSEQUENCES, DAMAGES, LOSSES,
            OR IMPACTS (INCLUDING INTERRUPTIONS OR DELAYS TO ANY OFFERING) THAT
            ARE CAUSED BY FORCE MAJEURE OR OTHER EVENTS OUTSIDE OF Rivergrove’S
            ABSOLUTE CONTROL, INCLUDING THE FOLLOWING: ANY WAR WHETHER DECLARED
            OR UNDECLARED, FIRE, FLOOD, EXTREME WEATHER, ACCIDENT, EXPLOSION,
            ACT OF TERRORISM, GOVERNMENTAL ORDERS, REGULATIONS, RESTRICTIONS OR
            PRIORITIES, STRIKE, LOCKOUT OR OTHER LABOR TROUBLES OR DISRUPTIONS,
            CYBER ATTACKS, CIVIL DISORDER, NATURAL DISASTERS, PUBLIC HEALTH
            EMERGENCY OR EPIDEMIC, DESTRUCTION OF NETWORK FACILITIES OR
            TRANSPORTATION INFRASTRUCTURE, OR ANY OTHER CAUSE BEYOND THE
            ABSOLUTE CONTROL OF Rivergrove.
            <br />
            <br />
          </p>
          <h3 id="13jurisdictionandchoiceoflaw">
            13. JURISDICTION AND CHOICE OF LAW
          </h3>
          <p>
            <br />
            This Agreement shall be governed by and construed in accordance with
            the laws of the State of Washington and the United States of
            America, without giving effect to any principles of conflicts of
            law.
            <br />
            <br />
          </p>
          <h3 id="14disputeresolution">14. DISPUTE RESOLUTION</h3>
          <p>
            <br />
            <strong>
              a. Mandatory Arbitration and Waiver of Class Actions
            </strong>
            <br />
            <br />
            PLEASE READ THIS SECTION CAREFULLY – IT SIGNIFICANTLY AFFECTS YOUR
            LEGAL RIGHTS, INCLUDING YOUR RIGHT TO FILE A LAWSUIT IN COURT.
          </p>
          <p>
            YOU AND Rivergrove AGREE THAT ANY DISPUTE, CONTROVERSY, OR CLAIM
            BETWEEN YOU OR ANY COVERED PARTY AND Rivergrove ARISING OUT OF, OR
            RELATING TO (1) THIS AGREEMENT, (2) YOUR OR ANY COVERED PARTY’S USE
            OF ANY OFFERING, (3) CONTENT, AND/OR (4) ANY RELATIONSHIP BETWEEN
            Rivergrove AND YOU OR ANY COVERED PARTY, (EACH OF (1) THROUGH (4), A
            “DISPUTE”), SHALL BE RESOLVED ONLY BY FINAL AND BINDING ARBITRATION,
            except that (a) either party may elect to proceed in small claims
            court in your county of residence within the U.S. if the Dispute
            qualifies; (b) this agreement to arbitrate does not include your,
            the Covered Parties’, or Rivergrove’s right to seek injunctive or
            other equitable relief in state or federal court in King County,
            Washington to prevent the actual or threatened infringement,
            misappropriation or violation of a party’s copyrights, trademarks,
            trade secrets, patents, or other intellectual property rights; and
            (c) if Rivergrove is named a defendant in any state or federal court
            action that implicates the parties’ indemnification rights or
            obligations under these Terms, then those rights or obligations may
            be litigated in that action. The arbitrator will have the authority
            to award the same remedies as a court, including preliminary or
            permanent injunctive relief, public injunctive relief, or equitable
            relief but only to the extent necessary to provide relief warranted
            by the individual claim before the arbitrator. The Federal
            Arbitration Act, 9 U.S.C. §§ 1, et seq., federal arbitration law,
            and Washington State law apply to this arbitration agreement and
            govern all questions as to whether a dispute is subject to
            arbitration.
            <br />
            <br />
            <strong>b. Notice of Dispute</strong>
            <br />
            <br />
            If you or any Covered Party have a dispute that our customer service
            representatives cannot resolve and you or any Covered Party wish to
            pursue arbitration, you must first complete the following steps
            before filing an arbitration claim:
            <br />
            1) you or the Covered Party must first send an individualized Notice
            of Dispute to us using this{" "}
            <Link onClick={toTop} to="/">
              Claim Form
            </Link>
            . The Notice of Dispute must be personally signed by you or the
            Covered Party, completed accurately and in full, be accompanied by
            documents reasonably needed to support your or the Covered Party’s
            claim (e.g., proof of purchase), and emailed to us at{" "}
            <Link onClick={toTop} to="mailto:depot@rivergrove.blog">
              depot@rivergrove.blog
            </Link>{" "}
            or sent by regular mail to: Notice of Dispute, Rivergrove LLC, 12515
            Cerise Ave, Hawthorne, CA 90250. We will provide you with a notice
            of dispute via your account’s primary email address if we have a
            dispute with you or a Covered Party. <br />
            2) Upon receipt of a Notice of Dispute, you, the Covered Party, and
            Rivergrove agree to negotiate in good faith for 60 days to try to
            resolve the dispute. <br />
            3) If either side requests a settlement conference duRartoria this
            period, then you, the Covered Party, and Rivergrove agree to
            schedule that conference by phone or videoconference and to
            personally participate in it. Either side can bRartoria counsel, but
            the conference must be individualized to our dispute, even if
            counsel represents other parties. For claims covered by the Notice
            of Dispute, any statute of limitations will be tolled from the date
            the notice is received until the later of (i) 60 days, or (ii) after
            a timely requested settlement conference is completed.{" "}
          </p>
          <p>
            A court can enjoin the filing or prosecution of an arbitration in
            breach of these pre-arbitration dispute resolution requirements. If
            either party seeks an injunction from a court on this basis, you,
            the Covered Party, and Rivergrove agree that the arbitration (and
            any obligation to pay arbitration fees) will be stayed until that
            request is resolved and all appeals exhausted.
            <br />
            <br />
            <strong>c. Arbitration Process and Procedure</strong>
            <br />
            <br />
            If the parties do not reach an agreed upon solution within sixty
            (60) days from the original Notice of Dispute, then either party may
            initiate binding arbitration as the sole means to resolve claims,
            subject to this Agreement. Arbitration shall: (1) be administered by
            JAMS pursuant to the{" "}
            <Link onClick={toTop} to="/">
              JAMS Streamlined Arbitration Rules &amp; Procedures
            </Link>{" "}
            and the{" "}
            <Link onClick={toTop} to="/">
              JAMS Mass Arbitration Procedures and Guidelines
            </Link>{" "}
            then in effect (together, the “JAMS Rules”); (2) be conducted by a
            single, neutral arbitrator; and (3) take place in the county where
            you or the Covered Party reside or any other location mutually
            agreed upon by the parties. If you or the Covered Party use the
            Rivergrove OffeRartoria that is the subject of the dispute for
            personal, non-commercial use, then the{" "}
            <Link onClick={toTop} to="/">
              JAMS Policy on Consumer Arbitrations Pursuant to Pre-Dispute
              Clauses Minimum Standards for Procedural Fairness
            </Link>{" "}
            (the “Minimum Standards”) shall apply, including any minimum
            standards governing consumer arbitration fees. If you or the Covered
            Party use the Rivergrove OffeRartoria that is the subject of the
            dispute for commercial use, then each party shall pay its pro rata
            share of JAMS’ fees and expenses in accordance with the JAMS Rules.
            The arbitrator shall issue a written award that states the
            disposition of each claim and provides a concise statement of the
            essential findings and conclusions on which the award is based. You,
            the Covered Parties, and Rivergrove each agree that the arbitrator
            shall have exclusive authority to resolve all disputes arising out
            of, or relating to, the interpretation, applicability,
            enforceability, or formation of this Agreement, including whether
            this arbitration agreement is enforceable and whether a particular
            claim or demand for relief is subject to arbitration under this
            Agreement. To the extent that this arbitration agreement conflicts
            with the Minimum Standards in any way, the Minimum Standards shall
            take precedence.{" "}
          </p>
          <p>
            YOU, THE COVERED PARTIES, AND Rivergrove EACH AGREE THAT (A) ANY
            ARBITRATION PROCEEDING FOR ANY DISPUTE WILL NOT BE CONDUCTED IN A
            CLASS OR REPRESENTATIVE ACTION, AND (B) BY ENTERartoria INTO THIS
            AGREEMENT (INCLUDING THIS AGREEMENT TO ARBITRATE), YOU, THE COVERED
            PARTIES, AND Rivergrove ARE, TO THE MAXIMUM EXTENT PERMITTED BY LAW,
            WAIVING THE RIGHT TO A TRIAL BY JURY, AND THE RIGHT TO PARTICIPATE
            IN A CLASS OR REPRESENTATIVE ACTION, WITH RESPECT TO ANY DISPUTE.
          </p>
          <p>
            However, if applicable law precludes the parties from arbitrating
            any claim or demand for relief in a Dispute, then that claim or
            demand for relief (and only that claim or demand for relief) must be
            severed from the arbitration and may be brought in state or federal
            court in King County, Washington. You, the Covered Parties, and
            Rivergrove agree that authority to determine whether applicable law
            precludes arbitrating any particular claim or demand for relief in a
            Dispute is delegated exclusively to the arbitrator and that if any
            such claim or demand for relief is severed as a result of the
            arbitrator’s decision and proceeds in court, then you, the Covered
            Parties, and Rivergrove are, to the maximum extent permitted by law,
            waiving the right to a trial by jury with respect to that claim or
            demand for relief.
            <br />
            <br />
          </p>
          <h3 id="15indemnification">15. INDEMNIFICATION</h3>
          <p>
            <br />
            You agree to indemnify Rivergrove for all claims, demands, actions,
            suits, damages, liabilities, losses, settlements, judgments, costs,
            and expenses, including but not limited to reasonable attorneys’
            fees and costs, arising out of or related to your Content or your or
            any Covered Party’s use of Rivergrove Offerings in violation of this
            Agreement.
            <br />
            <br />
          </p>
          <h3 id="16severabilityandsurvival">16. SEVERABILITY AND SURVIVAL</h3>
          <p>
            <br />
            If any part of this Agreement is deemed unlawful, void, or for any
            reason unenforceable, then that provision shall be deemed severable
            from the remaining terms of this Agreement and shall not affect the
            validity and enforceability of any remaining provisions.
          </p>
          <p>
            Provisions that, by their nature, should survive termination of this
            Agreement shall survive termination. By way of example, all of the
            following will survive termination: Section 4 (TRADEMARKS AND
            COPYRIGHTS, Section 10 (EXCLUSION OF LIABILITY), Section 11
            (LIMITATIONS OF LIABILITY), Section 13 (JURISDICTION AND CHOICE OF
            LAW), Section 14 (DISPUTE RESOLUTION), and Section 15
            (INDEMNIFICATION).
            <br />
            <br />
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Terms;
